// frontend/src/components/WebchatSettingsPanel/index.js
import React, { useEffect, useState } from "react";
import { Button, FormControlLabel, Switch, TextField, Typography } from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

/** Campos da página do webchat dentro do modal de conexão + link pronto para copiar. */
const WebchatSettingsPanel = ({ whatsAppId, values, setFieldValue }) => {
  const [link, setLink] = useState(null);
  const settings = values.webchatSettings || {};

  useEffect(() => {
    let alive = true;
    if (!whatsAppId) return undefined;
    api
      .get(`/webchat-admin/connections/${whatsAppId}`)
      .then(({ data }) => alive && setLink(data.url))
      .catch(() => alive && setLink(null));
    return () => {
      alive = false;
    };
  }, [whatsAppId]);

  const set = (key, value) => setFieldValue("webchatSettings", { ...settings, [key]: value });

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success(i18n.t("connections.webchat.linkCopied"));
    } catch (e) {
      toast.info(link);
    }
  };

  return (
    <div>
      <Typography variant="subtitle2" gutterBottom>{i18n.t("whatsappModal.webchat.section")}</Typography>
      <TextField
        id="webchat-title"
        fullWidth margin="dense" variant="outlined"
        label={i18n.t("whatsappModal.webchat.title")}
        helperText={i18n.t("whatsappModal.webchat.titleHelp")}
        inputProps={{ maxLength: 60 }}
        value={settings.title || ""}
        onChange={e => set("title", e.target.value)}
      />
      <TextField
        id="webchat-welcome-text"
        fullWidth margin="dense" variant="outlined" multiline minRows={3}
        label={i18n.t("whatsappModal.webchat.welcomeText")}
        helperText={i18n.t("whatsappModal.webchat.welcomeHelp")}
        inputProps={{ maxLength: 500 }}
        value={settings.welcomeText || ""}
        onChange={e => set("welcomeText", e.target.value)}
      />
      <FormControlLabel
        control={<Switch color="primary" checked={settings.requirePhone !== false} onChange={(_, v) => set("requirePhone", v)} />}
        label={i18n.t("whatsappModal.webchat.requirePhone")}
      />
      <Typography variant="subtitle2" style={{ marginTop: 16 }}>{i18n.t("whatsappModal.webchat.link")}</Typography>
      {link ? (
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <code style={{ wordBreak: "break-all" }}>{link}</code>
          <Button size="small" variant="outlined" onClick={copy}>{i18n.t("connections.webchat.copyLink")}</Button>
          <Button size="small" href={link} target="_blank" rel="noopener noreferrer">{i18n.t("connections.webchat.openPage")}</Button>
        </div>
      ) : (
        <Typography variant="body2" color="textSecondary">{i18n.t("whatsappModal.webchat.linkPending")}</Typography>
      )}
    </div>
  );
};

export default WebchatSettingsPanel;
